<template>
  <b-card
    no-body
    class="card-company-table"
  >
    <b-card-header>
      <b-card-title>{{ $t('Last Logged-in Users') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchCurrentLoggedInUsers"
      />
    </b-card-header>

    <b-table
      ref="accountOfficer"
      :items="currentLoggedInUsers"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      empty-text="No records available"
      class="mb-0"
    >
      <template #cell(role)="data">
        <p class="text-capitalize">
          {{ data.value }}
        </p>
      </template>
    </b-table>

    <Spinner :show="isLoadingCurrentLoggedInUsers" />
  </b-card>
</template>

<script>
import {
  BCard, BTable, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import { onMounted, computed, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'
import { toDateWithMinute } from '@/helpers/formatDate'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    Spinner,
  },

  setup() {
    const { getCurrentLoggedInUsers } = useActions({ getCurrentLoggedInUsers: 'dashboard/getCurrentLoggedInUsers' })
    const { t } = useI18nUtils()
    const { toastAlert } = useToastAlert()
    const currentLoggedInUsers = ref([])
    const tableHeaders = ref([
      { key: 'S/N', label: 'S/N' },
      { key: 'name', label: 'Name' },
      { key: 'branch', label: 'Branch' },
      { key: 'role', label: 'Role' },
      { key: 'timeLoggedIn', label: 'Time LoggedIn' },
    ])
    const translatedTableHeaders = computed(() => tableHeaders.value.map(header => ({ ...header, label: header.label ? t(header.label) : header.key })))
    const isLoadingCurrentLoggedInUsers = ref(false)

    const fetchCurrentLoggedInUsers = async () => {
      try {
        isLoadingCurrentLoggedInUsers.value = true
        const response = await getCurrentLoggedInUsers()

        const { status, data } = response
        if (status === 200 && data) {
          currentLoggedInUsers.value = data.map((item, index) => ({
            ...item,
            'S/N': index + 1,
            timeLoggedIn: toDateWithMinute(item.lastLoginDate),
          }))

          isLoadingCurrentLoggedInUsers.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingCurrentLoggedInUsers.value = false
      }
    }

    onMounted(async () => {
      await fetchCurrentLoggedInUsers()
    })

    return {
      currentLoggedInUsers,
      tableHeaders,
      isLoadingCurrentLoggedInUsers,
      fetchCurrentLoggedInUsers,
      translatedTableHeaders,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
